import { combineReducers } from 'redux';

import consultarProcesso from './consultarProcesso/reducer';
import consultarCin from './consultarCin/reducer';
import consultarCinPPT from './consultarCinPPT/reducer';
import consultarCpfCinResponsavel from './consultarCpfCinResponsavel/reducer';

export default combineReducers({
	consultarProcesso,
	consultarCin,
	consultarCinPPT,
	consultarCpfCinResponsavel,
});
